export default {
  title: 'This restaurant can’t go live yet',
  description:
    'Your partner account has no processing fee for online payments and hasn’t confirmed a 0% margin. Stripe charges its fees to your platform, so one of the two has to be decided first.',
  partner_action:
    'Set a default processing fee, or confirm that you charge your restaurants none and pay Stripe’s fees yourself.',
  ask_partner:
    'Your partner hasn’t set its processing fee for online payments yet. This restaurant can go live once it has.',
  buttons: {
    set_rate: 'Set processing fee',
    close: 'Close',
  },
};
